import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import Input from "../../../../components/Common/Input/Input";
import Modal from "../../../../components/Common/Modal/Modal";
import { getPollByIdHandler } from "../../../../store/actions/actionHandlers/socialActionHandler";
import classes from "./ViewPollModal.module.scss";
import { FormattedMessage } from "react-intl";

const ViewPollModal = ({ isViewModal, setisViewModal, pollId }) => {
  const methods = useForm({});
  const dispatch = useDispatch();
  const [viewPollData, setviewPollData] = useState({});
  useEffect(() => {
    if (pollId)
      dispatch(getPollByIdHandler(pollId, new Date(), setviewPollData));
  }, [pollId, dispatch]);

  return (
    <Modal
      isOpen={isViewModal}
      heading={<FormattedMessage id="P_REVIEW" />}
      toggle={() => setisViewModal(false)}
      width={"50"}
    >
      <div className={classes.viewPoll}>
        <div className={classes.questionSection}>
          <p className={classes.questionHeading}><FormattedMessage id="QUESTION" /></p>
          <div className={classes.questionText}>
            <p className={classes.questionName} title={viewPollData?.Question}>
              {viewPollData?.Question}
            </p>
          </div>
        </div>
        
        <div className={classes.optionsSection}>
          <p className={classes.optionsHeading}>Options</p>
          <div className={classes.optionsFrame}>
            {viewPollData?.Options?.map((item, index) => {
              return (
                <div className={classes.optionItem} key={`option-${index}`}>
                  <span className={classes.optionNumber}>{index + 1}.</span>
                  <div className={classes.optionContent}>
                    <FormProvider {...methods}>
                      <Input
                        label={item}
                        name={`option${index}`}
                        fieldName={`option${index}`}
                        type="radio"
                        labelColor="dark"
                        direction="row-reverse"
                        width="2"
                        height="2"
                        disabled
                        title={item}
                      />
                    </FormProvider>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ViewPollModal;
